var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compose page"},[_c('transition',{attrs:{"name":"slide","enter-active-class":"animated slideInRight delay","leave-active-class":"animated slideOutLeft"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }